/**
 * El rango salarial de una vacante, como lo muestra el diseño.
 *
 * Sale en un solo renglón —`$45,000.00–$50,000.00MXN`— y no como dos campos,
 * porque lo que se consulta es el rango, no cada extremo por separado. La
 * edición sí sigue con sus dos campos: ahí se capturan uno y otro.
 *
 * Los valores llegan como texto desde el formulario y como número desde la
 * API, así que se aceptan los dos. Lo que no se puede leer como número no se
 * inventa: se trata como ausente.
 */

const PESOS = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** El monto con su signo y separadores, o null si no hay nada que mostrar. */
function monto(valor: unknown): string | null {
  if (valor === null || valor === undefined || valor === '') return null

  const numero = typeof valor === 'number' ? valor : Number(String(valor).trim())
  if (!Number.isFinite(numero)) return null

  // `formatToParts` para quitar el espacio que `es-MX` mete entre el signo y
  // la cifra en algunos entornos: el diseño lo pide pegado.
  return PESOS.format(numero).replace(/\s/g, '')
}

/**
 * El rango listo para pintar, o null si no se capturó ninguno de los dos.
 *
 * Con un solo extremo se muestra ese: media vacante con sueldo dice más que
 * un «Sin asignar» que esconde el dato que sí existe.
 */
export function rangoSalarial(minimo: unknown, maximo: unknown): string | null {
  const desde = monto(minimo)
  const hasta = monto(maximo)

  if (desde && hasta) return `${desde}–${hasta}MXN`
  if (desde) return `Desde ${desde}MXN`
  if (hasta) return `Hasta ${hasta}MXN`

  return null
}
